import React, { useEffect, useState } from "react";
import api from "../../api/api";

export default function AdminPages({ onEdit }) {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      const res = await api.get("/admin/pages");
      setPages(res.data.pages || []);
      setLoading(false);
    }
    load();
  }, []);

  if (loading) return <p>Carregando...</p>;

  if (!pages.length)
    return (
      <div className="text-center py-20 opacity-70">
        Nenhuma página cadastrada
      </div>
    );

  return (
    <div className="space-y-4">
      {pages.map((page) => (
        <div
          key={page.id}
          className="card flex items-center justify-between"
        >
          <div>
            <h3 className="font-bold">{page.title}</h3>
            <p className="text-sm opacity-60">/{page.slug}</p>
          </div>

          <button
            className="btn btn-primary"
            onClick={() => onEdit(page.slug)}
          >
            Editar
          </button>
        </div>
      ))}
    </div>
  );
}
